import React from "react";
import "../../Stylesheets/WhyChooseUs/WhyChooseUs.scss";
import highquality from "../../assests/Images/Whychoose/highquality.png";
import autoblur from "../../assests/Images/Whychoose/autoblur.png";
import branding from "../../assests/Images/Whychoose/branding.png";
import alldevices from "../../assests/Images/Whychoose/alldevices.png";
import pricing from "../../assests/Images/Whychoose/pricing.png";

const WhyChooseUs = () => {
  return (
    <div className="whychooseus-main-wrapper background_color_black">
      <div className="whychooseus-inner-wrapper">
        <div className="card-main-wrapper container-fluid">
          <div class="row row-cols-1 row-cols-md-2 g-4">
            {/* heading-col */}
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 head-col">
              <div class="head-card">
                <div className="head-body">
                  <div className="card-heading">
                    <button>
                      <span className="chooseus-text">Why Choose Us ?</span>
                    </button>
                  </div>
                  <div className="card-head-content">
                    <div className="head-text">
                      Creating a 360 virtual tour is easy, but crafting a
                      masterful experience is the true challenge and that is
                      where our expertise lies. We combine photography with the
                      right technology to achieve this.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* content-col */}
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 rest_col_right" >
              <div class="card">
                <div className="row-12 card-body">
                  <div className="col-2 card-img">
                    <img
                      src={highquality}
                      alt="high quality"
                      className="whychooseimg"
                    ></img>
                  </div>
                  <div className="col-10 card-content">
                    <h3 className="card-content-head">High-Quality Images</h3>
                    <p className="card-head-underline"></p>
                    <p className="card-content-desc">
                      Our 360 Virtual Tours utilize cutting-edge technologies to
                      capture high-quality images that blur the line between
                      reality to ensure viewers are truly immersed in the tour.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 rest_col">
              <div class="card">
                <div className="row-12 card-body">
                  <div className="col-2 card-img">
                    <img
                      src={branding}
                      alt="high quality"
                      className="whychooseimg"
                    ></img>
                  </div>
                  <div className="card-10 card-content">
                    <h3 className="card-content-head">Custom Branding</h3>
                    <p className="card-head-underline"></p>
                    <p className="card-content-desc">
                      Make the 360 Virtual Tours we deliver your own by
                      customizing all crucial elements of the tour with your
                      branding colors and style to ensure it fits right into
                      your website or any platform you wish to use.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 rest_col_right">
              <div class="card">
                <div className="row-12 card-body">
                  <div className="col-2 card-img">
                    <img
                      src={alldevices}
                      alt="high quality"
                      className="whychooseimg"
                    ></img>
                  </div>
                  <div className="col-10 card-content">
                    <h3 className="card-content-head">
                      Compatible on All Devices
                    </h3>
                    <p className="card-head-underline"></p>

                    <p className="card-content-desc">
                      Easily share your 360 Virtual Tours with just a link that
                      can be viewed on mobiles, tablets, computers, or even VR
                      headsets without compromising on the experience.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 rest_col">
              <div class="card">
                <div className="row-12 card-body">
                  <div className="col-2 card-img">
                    <img
                      src={autoblur}
                      alt="high quality"
                      className="whychooseimg"
                    ></img>
                  </div>
                  <div className="col-10 card-content">
                    <h3 className="card-content-head">
                      Auto Blur Faces and Other Sensitive Data
                    </h3>
                    <p className="card-head-underline"></p>

                    <p className="card-content-desc">
                      Our AI-enabled solution will ensure you protect the
                      privacy of people or the security of the premises by
                      blurring out sensitive data such as people's faces,
                      vehicle numbers, and so on.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 rest_col_right">
              <div class="card">
                <div className="row-12 card-body">
                  <div className="col-2 card-img">
                    <img
                      src={pricing}
                      alt="high quality"
                      className="whychooseimg"
                    ></img>
                  </div>
                  <div className="col-10 card-content">
                    <h3 className="card-content-head">Competitive Pricing</h3>
                    <p className="card-head-underline"></p>

                    <p className="card-content-desc">
                      Our efficient workflow enables us to deliver the highest
                      value without compromising on the pricing and our pricing
                      model is suitable for all types of business.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
